// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.not-found:before,\n.not-found:after {\n  content: ' ';\n  display: table;\n}\n.not-found.page-level {\n  text-align: center;\n}\n.not-found > img {\n  height: 300px;\n  margin-top: 100px;\n  margin-bottom: 45px;\n}\n.not-found > .header {\n  font-weight: 600;\n  font-size: 16px;\n  color: #373737;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
